import { ProductData, ActionData } from './data';
import { push } from './dataLayer';
import { Product, ArticleType } from '../mrCapTypes';

/**
 * Convert a MrCAP product into a GTM product data object.
 *
 * @param product Object to convert.
 * @param campaignCode Campaign code if used.
 */
export function convertProduct(product: Product, campaignCode?: string): ProductData {
  return {
    id: product.articleNr,
    name: product.title,
    brand: 'MrCAP',
    category: (ArticleType as any)[product.type],
    quantity: 1,
    price: product.salePriceVehicle ?? product.priceVehicle,
    coupon: campaignCode ?? ''
  };
}

export function addProductToCart(product: ProductData) {
  push({
    event: 'addToCart',
    ecommerce: {
      currencyCode: 'SEK',
      add: {
        products: [product]
      }
    }
  });
}

export function removeProductFromCart(product: ProductData) {
  push({
    event: 'removeFromCart',
    ecommerce: {
      currencyCode: 'SEK',
      remove: {
        products: [product]
      }
    }
  });
}

export function productDetail(product: ProductData, list: string) {
  push({
    event: 'productDetail',
    ecommerce: {
      detail: {
        actionField: {
          list
        },
        products: [product]
      }
    }
  });
}

export function checkout(products: ProductData[], step?: number, option?: string) {
  push({
    event: 'checkout',
    ecommerce: {
      checkout: {
        actionField: {
          step,
          option
        },
        products
      }
    }
  });
}

export function checkoutOption(step: number, option: string) {
  push({
    event: 'checkoutOption',
    ecommerce: {
      'checkout_option': {
        actionField: {
          step,
          option
        }
      }
    }
  });
}

export function purchase(details: ActionData, products: ProductData[]) {
  push({
    event: 'purchase',
    ecommerce: {
      purchase: {
        products,
        actionField: details
      }
    }
  });
}